import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion, useScroll } from "framer-motion";
import Lenis from "lenis";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";
import Preloader from "@/components/Preloader";
import { Marquee } from "@/components/Marquee";
import { trackConversion } from "@/lib/track";

export default function Layout() {
  const lenisRef = useRef(null);
  const { pathname } = useLocation();
  const { scrollYProgress } = useScroll();

  useEffect(() => {
    const handler = (e) => {
      const a = e.target.closest && e.target.closest("a");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      if (href.startsWith("tel:") || href.includes("wa.me")) trackConversion();
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });
    lenisRef.current = lenis;
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);

  useEffect(() => {
    lenisRef.current?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-cream text-ink font-body relative">
      <Header />
      <main data-testid="page-main" className="relative">
        <Outlet />
      </main>
      <Marquee dark />
      <Footer />
      <div className="h-[58px] md:hidden" aria-hidden />
      <motion.div
        aria-hidden
        className="fixed top-0 left-0 right-0 h-[2px] z-[90] origin-left bg-gradient-to-r from-[#8e6a32] via-[#d4ad6a] to-[#f0d99e]"
        style={{ scaleX: scrollYProgress }}
      />
      <FloatingButtons />
      <Preloader />
    </div>
  );
}
